import React from 'react';
import { Container } from 'semantic-ui-react';

const RequestPasswordReset = () => {
  return (
    <Container id="page-password-reset">
      <div className="ui segment">
        <div className="ui segment primary">
          <h1 style={{ fontSize: '16px' }}>Hai dimenticato la tua password?</h1>
        </div>
        <div className="ui secondary segment">
          <p>
            L'autenticazione sul portale di Ateneo UniBa.it è riservata al personale autorizzato.
            <br />
            Non sono previsti accessi autenticati da parte di studenti, imprese o
            personale esterno che non abbiano un ruolo attivo all'interno del portale.
          </p>
          <p>
            <span>La gestione delle credenziali si effettua dal portale</span>
            <br />
            <a href="https://mondo.ict.uniba.it">
              https://mondo.ict.uniba.it
            </a>
          </p>
        </div>
      </div>
    </Container>
  );
};

export default RequestPasswordReset;
